import { render, staticRenderFns } from "./editData.vue?vue&type=template&id=baaea528&scoped=true&"
import script from "./editData.vue?vue&type=script&lang=js&"
export * from "./editData.vue?vue&type=script&lang=js&"
import style0 from "./editData.vue?vue&type=style&index=0&id=baaea528&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaea528",
  null
  
)

export default component.exports